export default {
  SET_OVG_DETAIL(state, ovg) {
    state.ovgDetail = ovg
  },
  PATCH_OVG_ESTADO(state, patch) {
    if (state.ovgDetail) {
      state.ovgDetail = { ...state.ovgDetail, ...patch }
    }
  },
}
